<template>
  <card :card-title="$t('homepage.txt003')" title-image="shortcut">
    <!--<template #ope>-->
      <!--<i class="operation-icon el-icon-s-tools" @click="handleSet"></i>-->
    <!--</template>-->
    <div class="shortcut-list">
      <div :class="shortcut.hasPermission? 'shortcut-item' : 'shortcut-item-no'" v-for="(shortcut, index) in menus" :key="shortcut.id" @click="clickShortcut(shortcut)">
        <el-image class="shortcut-icon" :src="getShortcutIcon(shortcut)" fit="cover"></el-image>
        <div class="shortcut-name">{{ $t(shortcut.shortcutName) }}</div>
      </div>
    </div>
  </card>
</template>

<script>
  import Card from './Card'
  export default {
    name: "Shortcuts",
    components: {
      Card
    },

    props: {
      menus: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
      }
    },
    methods: {
      getShortcutIcon(shortcut) {
        return require(`@/assets/img/icon/${ shortcut.iconName }.png`)
      },
      // 配置
      handleSet() {
        this.$message.warning('功能建设中...')
      },
      clickShortcut(shortCut){
        if(!shortCut.hasPermission){
          return;
        }

        var optParam = null;
        if(shortCut.shortcutName == "homepage.shortCut001" && shortCut.url == '/costApplication/costEdit'){ //付款申请
          optParam = {
            costId : '',
            editFlag : 'add'
          };
        }
        //console.log("toEditpage");
        //console.log(this.optParam);
        this.$router.push({path:shortCut.url,query: optParam});
      },
    }
  }
</script>

<style lang="scss" scoped>
  .shortcut-list {
    height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    .shortcut-item {
      width: 100px;
      text-align: center;
      line-height: 1;
      cursor: pointer;
      flex-shrink: 0;
    }
    .shortcut-item-no {
      width: 100px;
      text-align: center;
      line-height: 1;
      cursor: no-drop;
      flex-shrink: 0;
      .shortcut-icon {
        filter: grayscale(100%) brightness(125%);
      }
    }
    .shortcut-icon {
      width: 40px;
      height: 40px;
    }
    .shortcut-name {
      margin-top: 10px;
    }
  }
</style>
